import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import Bills from "./Bills";

const BillingRequestModal = ({ selectedMatter, onClose, onSubmitSuccess }) => {
  return (
    <Dialog
      onClose={onClose}
      title={"Add Billing Request"}
      className="batch-posting-dialog dialog-xxxl">
      <Bills
        component="BillingRequest"
        isDialog={true}
        onClose={onClose}
        onSubmitSuccess={onSubmitSuccess}
        selectedMatter={selectedMatter}
      />
    </Dialog>
  );
};

export default BillingRequestModal;
